import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["siteSchedule", "filters", "filter", "filterTemplate"]
  static values = {
    scheduleLabel: String,
    siteLabel: String,
    regionLabel: String,
    regions: Array
  }

  connect() {
    this.filters = []
    this.all = false
    this.renderFiltersDebounced = debounce(this.renderFilters.bind(this), 100, false);
  }

  filterSelected(event) {
    const select = event.currentTarget;
    let type = select.dataset.type;
    let value = select.value;
    if (type === 'site') {
      [type, value] = value.split('--');
    }
    if (value === "All") {
      this.filters = []
      this.all = true
    } else {
      this.filters.push([type, value]);
      this.all = false
    }
    select.value = '';
    this.updateFilters();
  }

  removeFilter(event) {
    const el = event.currentTarget;
    const type = el.dataset.type;
    const value = el.dataset.value;
    if (this.all) {
      this.filters = [];
      this.all = false;
    } else {
      this.filters = this.filters.filter(([t, v]) => !(t === type && v === value));
    }
    this.updateFilters();
  }

  siteScheduleSelected(event) {
    const el = event.currentTarget;
    this.selectSiteSchedule(el);
  }

  selectAllSiteSchedules() {
    this.siteSchedulesWithFilterStatus((ss, show) => {
      if (show && ss.dataset.selected !== 'true') {
        this.selectSiteSchedule(ss);
      }
    });
  }

  deselectAllSiteSchedules() {
    this.siteScheduleTargets.forEach((ss) => {
      if (ss.dataset.selected === 'true') {
        this.selectSiteSchedule(ss);
      }
    });
    this.updateFilters();
  }

  selectSiteSchedule(ss) {
    ss.dataset.selected = !(ss.dataset.selected === 'true');
    ss.querySelectorAll('input').forEach((input) => {
      input.disabled = !input.disabled;
    });
    this.updateFilters(); // this will cause selected site schedules to be removed from the UI if they should be hidden according to the filter status
  }

  renderFilters() {
    const filterElements = this.all ? [this.buildFilter()] : this.filters.map(([type, value]) => this.buildFilter(type, value));
    this.filtersTarget.innerHTML = '';
    filterElements.forEach((el, index) => {
      if (index !== 0) {
        const span = document.createElement('span')
        span.classList.add('text-muted')
        span.textContent = 'or';
        this.filtersTarget.appendChild(span);
      }
      this.filtersTarget.appendChild(el)
    });
    this.filterSiteSchedules();
  }

  updateFilters() {
    this.renderFiltersDebounced();
  }

  siteSchedulesWithFilterStatus(fn) {
    const map = new Map()
    this.filters.forEach(([_type, value]) => {
      map.set(value, true);
    })
    useViewTransition(() => {
      if (map.size === 0) {
        this.siteScheduleTargets.forEach((site) => fn(site, site.dataset.selected === 'true' || this.all));
        return;
      }
      this.siteScheduleTargets.forEach((site) => {
        let show = site.dataset.selected === 'true' || map.has(site.dataset.site) || map.has(site.dataset.schedule) || map.has(site.dataset.region) || map.has(site.dataset.country);
        fn(site, show)
      });
    });
  }

  filterSiteSchedules() {
    this.siteSchedulesWithFilterStatus((site, show) => {
      site.classList.toggle('hide', !show);
    });
  }

  typeLabel(type) {
    if (type === 'site') {
      return this.siteLabelValue;
    } else if (type === 'schedule') {
      return this.scheduleLabelValue;
    } else {
      return this.regionLabelValue;
    }
  }

  buildFilter(type, value) {
    const clone = this.filterTemplateTarget.content.cloneNode(true);
    if (this.all) {
      clone.querySelector('.badge-label').textContent = 'All';
    } else {
      clone.querySelector('.badge-label').textContent = `${this.typeLabel(type)}: ${value}`;
    }
    const close = clone.querySelector('.close');

    close.dataset.type = type;
    close.dataset.value = value;

    return clone;
  }
}
